export const INVALID_FORM_WARNING =
  "Please fill out all required fields, or remove features that you don't need to include.";
